import { StringOption } from 'interfaces/forms/types';
import { TriggerType } from 'models/signature-requirement/types';

export const searchFieldPlaceholder = 'Search by keyword';
export const initialSearchTerm = '';
export const debounceTimeMs = 500;
export const triggerTypeDebounceTimeMs = 300;

export const TRIGGER_TYPE_OPTIONS: StringOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Insurance', value: TriggerType.Insurance },
  { label: 'Cold Chain', value: TriggerType.ColdChain },
  { label: 'Controlled Substance', value: TriggerType.ControlledSubstance },
  { label: 'Specialty Medication Flag', value: TriggerType.SpecialtyMedication },
];

export const TRIGGER_TYPE_LABELS: Record<TriggerType, string> = {
  [TriggerType.Insurance]: 'Insurance',
  [TriggerType.ColdChain]: 'Cold Chain',
  [TriggerType.ControlledSubstance]: 'Controlled Substance',
  [TriggerType.SpecialtyMedication]: 'Specialty Medication Flag',
};
